import { Component } from '@angular/core';
import { ClickOutSideDirective } from '../../../../../directives/click-out-side.directive';
import { FeatherIconComponent } from '../../../feather-icon/feather-icon.component';
import { CommonService } from '../../../../../services/common.service';
import { Router, RouterLink, RouterLinkActive, NavigationEnd } from '@angular/router';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap, of, filter } from 'rxjs';

@Component({
  selector: 'app-search-box',
  standalone: true,
  imports: [FeatherIconComponent, ClickOutSideDirective, ReactiveFormsModule, RouterLink, RouterLinkActive],
  templateUrl: './search-box.component.html',
  styleUrl: './search-box.component.scss'
})

export class SearchBoxComponent {

  public isOpen: boolean = false;
  public filteredData: any[] = []; // Données filtrées
  public isLoading: boolean = false;

   // ✅ Déclaration du champ de recherche
   TopSearchControl = new FormControl('');

  constructor(public commonServices: CommonService, private router: Router) {

  }

  ngOnInit() {
    // Écouter les changements de la barre de recherche avec RxJS
    this.TopSearchControl.valueChanges
      .pipe(
        debounceTime(300), // ✅ Attendre 300ms après la dernière entrée
        distinctUntilChanged(), // ✅ Ne pas répéter la même valeur
        switchMap(searchText => {
          if (searchText && searchText.length >= 3) {
            this.isLoading = true;
            return this.commonServices.getAllCelebrities(1, { search: searchText });
          } else {
            this.isLoading = false;
            return of(null);
          }
        })
      )
      .subscribe(response => {
        this.isLoading = false;
        if (response && response.data) {
          this.filteredData = response.data;
          this.isOpen = true;
        } else {
          this.filteredData = [];
           // On ne force pas la fermeture ici pour éviter des clignotements si l'utilisateur vide le champ, 
           // mais si le champ est vide ou < 3 chars, filteredData est vide donc la liste sera vide.
           // Cependant si on veut cacher la boite quand il n'y a pas de résultats:
           if(!response) {
               // keep open to show the "please type" message if focused, handled by template
           }
        }
      });

    // Fermer la liste de suggestions lors de la navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.isOpen = false;
        this.TopSearchControl.setValue('', { emitEvent: false });
        this.filteredData = [];
      });
  }

  outSideClose() {
    this.isOpen = false;
  }

}
